import React, { useEffect, useState } from 'react'
import { CiLocationOn } from "react-icons/ci";
import SearchInput from '../SearhInput';
import { GiFallingStar } from "react-icons/gi";
import { TbHomePlus, TbHotelService } from "react-icons/tb";
import { useTranslation } from 'react-i18next';
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom'
import { FaRegCalendarAlt } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSubCategoryByCategory } from '../../../features/admin/placeSlice';
import { AppDispatch, RootState } from '../../../store';
import { setDates } from '../../../features/home/bookingSlice';
import toast from 'react-hot-toast';
const StayForm = () => {
    const { t, i18n } = useTranslation();
    const [destination, setDestination] = useState("");
    const [checkIn, setCheckIn] = useState("");
    const [checkOut, setCheckOut] = useState("");
    const [rate, setrate] = useState<number>();
    const [rooms, setRooms] = useState<number>();
    const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<number | null>(null);

    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const { subCategories } = useSelector((state: RootState) => state.placeSlice);

    useEffect(() => {
        dispatch(fetchSubCategoryByCategory(1));
    }, [dispatch]);

    const selectedSubCategory = subCategories?.find((subCategory: any) => subCategory.id === selectedSubCategoryId);
    const isHotel = selectedSubCategory?.id === 1;

useEffect(() => {
  const handler = (e: KeyboardEvent) => {
    if (e.code === "Space") console.log("Pressed Space");
  };
  document.addEventListener("keydown", handler);
  return () => document.removeEventListener("keydown", handler);
}, []);


    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault();

        let messages: string[] = [];

        if (!destination) messages.push(`• ${t("requiredDestination")}`);
        if (!checkIn || !checkOut) {
            messages.push(`• ${t("requiredDates")}`);
        } else {
            const checkInDate = new Date(checkIn);
            const checkOutDate = new Date(checkOut);

            if (checkOutDate <= checkInDate) {
                messages.push(`• ${t("checkoutAfterCheckin")}`);
            }
        }
        if (isHotel && !rooms) messages.push(`• ${t("requiredRooms")}`);
 
        if (messages.length > 0) {
            toast.error( 
                `${t("incompleteFields")}\n${messages.join('\n')}`,
                {
                    style: {
                        whiteSpace: 'pre-line',
                        direction: `${i18n.language === "ar" ? "rtl" : "ltr"}`,
                    },
                }
            );
            return;
        }

        const params = new URLSearchParams();
        if (destination) params.append("destination", destination);
        if (checkIn && checkOut) {
            const checkInDate = new Date(checkIn);
            const checkOutDate = new Date(checkOut);

            params.append("checkIn", checkInDate.toISOString());
            params.append("checkOut", checkOutDate.toISOString());

            dispatch(setDates({ checkIn: checkInDate, checkOut: checkOutDate }));
        }
        if (rate) params.append("rate", rate.toString());
        if (rooms && isHotel) params.append("numberOfRooms", rooms.toString());
        if (selectedSubCategoryId) params.append("subCategoryId", selectedSubCategoryId.toString());

        navigate(`/stay-search-result?${params.toString()}`);
    };



    return (
        <div className={`px-3 rounded-b-lg ${i18n.language === "ar" ? "rounded-tl-lg" : "rounded-tr-lg"}`}>
            <form onSubmit={handleSearch} className="grid xs:grid-cols-2 md:grid-cols-6 items-end py-8 gap-2">

                {/* Destination */}

                <SearchInput
                    value={destination}
                    type="text"
                    onChange={setDestination}
                    placeholder={t("destination-placeholder")}
                    label={t("destination-label")}
                    icon={<CiLocationOn />}
                />


                {/* Check In */}
                <div className=' '>
                    <SearchInput
                        value={checkIn}
                        type="date"
                        onChange={setCheckIn}
                        placeholder={t("checkin-placeholder")}
                        label={t("checkin-label")}
                        icon={<FaRegCalendarAlt />}
                    />
                </div>
                {/* Check Out */}
                <div className=' '>
                    <SearchInput
                        value={checkOut}
                        type="date"
                        onChange={setCheckOut}
                        placeholder={t("checkout-placeholder")}
                        label={t("checkout-label")}
                        icon={<FaRegCalendarAlt />}
                    />
                </div>
                <SearchInput
                    type="select"
                    value={selectedSubCategoryId ?? ""}
                    onChange={(val) => setSelectedSubCategoryId(Number(val))}
                    label={t("subcategory-label")}
                    placeholder={t("select-subcategory")}
                    icon={<TbHotelService />}
                    options={[
                        { value: "", label_ar: t("select-subcategory"), label_en: t("select-subcategory") },
                        ...(Array.isArray(subCategories)
                            ? subCategories.map((sub: any) => ({
                                value: sub.id,
                                label_ar: sub.title_ar || sub.title,
                                label_en: sub.title_en || sub.title,
                            }))
                            : [])
                    ]}
                />

                {/* Rooms (only if Hotels selected) */}
                {isHotel ? (
                    <SearchInput
                        value={rooms}
                        type="number"
                        onChange={setRooms}
                        placeholder={t("rooms-placeholder")}
                        label={t("rooms-label")}
                        icon={<TbHomePlus />}
                    />
                ) : (
                    <SearchInput
                        value={rate}
                        type="number"
                        onChange={setrate}
                        placeholder={t("rate-placeholder")}
                        label={t("rate-label")}
                        icon={<GiFallingStar />}
                    />
                )}

                {/* Submit Button */}
                <button
                    type="submit"
                    className="flex-center h-fit gap-2 px-4 py-2 bg-primary text-white rounded-lg "
                >
                    {t("search")}
                    {i18n.language === "ar" ? <FaArrowLeftLong /> : <FaArrowRightLong />}
                </button>
            </form>
        </div>
    )
}

export default StayForm;
